module.exports = __webpack_public_path__ + "img/12.0e587c6b.png";